
    import LocalStorage from './localStorage'

    let key = 'CustomDimension';
    let objCustomDimension = {};
    const get = function () {
        objCustomDimension = LocalStorage.getItem(key);
        return objCustomDimension;
    }

    /*const clear = function () {
        objCustomDimension = {};
        LocalStorage.removeItem(key);
    }*/

    const set = function (prop, value) {
        if (!objCustomDimension) objCustomDimension = {};
        objCustomDimension[prop] = value;
        return objCustomDimension;
    }


    const save = function () {
        LocalStorage.setItem(key, objCustomDimension);
    }

    const exist = function () {
        return get() !== null;
    }



    const setSuscriptorType = function (value) {
        set('suscriptorType', value);
    }
    const setRegistrado = function (value) {
        set('usuarioRegistrado', value);
    }
    const setUserId = function (value) {
        set('userId', value);
    }

    export default {
        get,
        exist,
        setRegistrado,
        setSuscriptorType,
        setUserId,
        save
    }


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/customDimension.js